import React from 'react';

export const DiagramColumn = React.forwardRef(function DiagramColumn(
	{ diagram, isLastVendorRow },
	ref,
) {
	if (!diagram) return null;
	const src = diagram
		? `https://cdn11.bigcommerce.com/s-le3vzvrwix/product_images/uploaded_images/${diagram.toLowerCase()}.jpg`
		: '';

	return (
		<div
			ref={ref}
			style={{
				width: '48px',
			}}
		>
			<img className={'diagramImage'} src={src} alt={diagram} />
		</div>
	);
});
